export default __webpack_public_path__ + "static/media/bi_check2-square.218937e0.svg";